import routes from '@/modules/permissions/permissions-routes';
import store from '@/modules/permissions/permissions-store';
export default {
    component: [],
    routes,
    store,
}
